import { render } from "./ListAtivacao.vue?vue&type=template&id=56bd9411&scoped=true"
import script from "./ListAtivacao.vue?vue&type=script&lang=js"
export * from "./ListAtivacao.vue?vue&type=script&lang=js"

import "./ListAtivacao.vue?vue&type=style&index=0&id=56bd9411&scoped=true&lang=css"
import "./ListAtivacao.vue?vue&type=style&index=1&id=56bd9411&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bd9411"]])

export default __exports__